import { all, call, put, takeEvery, select } from 'redux-saga/effects';
import { withApiErrorHandling } from '../helpers/sagaHelper';
import { getPropertySuccess } from '../actions/propertyActions';
import * as types from '../actions/actionType';
import session from 'containers/App/session';
import { statsService } from 'utils/api';

export function* getPropertyByMonth(action) {
    const token = yield select(session.selectors.selectUserToken);
    yield* withApiErrorHandling(function* fetchPropertyByMonth() {
        const apiDateFormat = 'YYYY-MM-DD';
        const startDate = action.startDate.format(apiDateFormat);
        const endDate = action.endDate.format(apiDateFormat);
        const lyStartDate = action.lyStartDate.format(apiDateFormat);
        const lyEndDate = action.lyEndDate.format(apiDateFormat);

        const [monthData, budgetData, lySpit] = yield all([
            call(statsService({ token, propertyId: action.id }).getFinalRoomsAndRevenueByDay, {
                start: startDate,
                end: endDate,
            }),
            call(statsService({ token, propertyId: action.id }).getBudgetByDay, {
                start: startDate,
                end: endDate,
            }),
            call(statsService({ token, propertyId: action.id }).getLySpitRoomsAndRevenueByDay, {
                start: lyStartDate,
                end: lyEndDate,
            }),
        ]);
        const response = {
            data: monthData.data,
            budget: budgetData.data,
            lySpit: lySpit.data,
        };
        yield put(getPropertySuccess(types.GET_PROPERTY_BY_MONTH_SUCCESS, response));
    });
}
export function* watchGetPropertyByMonth() {
    yield takeEvery(types.GET_PROPERTY_BY_MONTH, getPropertyByMonth);
}
